
(function () {
  var P = JSON.parse(document.getElementById("ts-fw-catalog").textContent);

  // Temperature bands, in degrees Fahrenheit at the start of the run.
  var BANDS = [
    { id: "bitter", min: 20, max: 27, name: "Bitter", preset: 24,
      text: "Everything you have, and a wind shell of your own over the top. Head out into the wind so it's at your back on the way home.",
      kit: [["brighton", "Base"], ["harrier", "Over"], ["turnover", "Legs"], ["gloves", "Hands"], ["beanie", "Head"], ["socks", "Feet"]] },
    { id: "cold", min: 28, max: 37, name: "Cold", preset: 32,
      text: "Frost on the windshield. Seamless merino against the skin with the Harrier over it, and the brushed tights.",
      kit: [["brighton", "Base"], ["harrier", "Over"], ["turnover", "Legs"], ["gloves", "Hands"], ["beanie", "Head"], ["socks", "Feet"]] },
    { id: "brisk", min: 38, max: 47, name: "Brisk", preset: 42,
      text: "Cold enough to see your breath. Full-length tights, gloves, and a beanie you'll pull off by mile three.",
      kit: [["harrier", "Top"], ["turnover", "Legs"], ["gloves", "Hands"], ["beanie", "Head"], ["socks", "Feet"]] },
    { id: "crisp", min: 48, max: 57, name: "Crisp", preset: 52,
      text: "The best running weather of the year. Merino up top, half tights below, and a cap for the low sun.",
      kit: [["harrier", "Top"], ["twilight", "Legs"], ["hat", "Head"], ["socks", "Feet"]] },
    { id: "mild", min: 58, max: 65, name: "Mild", preset: 61,
      text: "Long sleeves for the first mile and shorts for the rest. October still hands out a few of these.",
      kit: [["vancortlandt", "Top"], ["shorts", "Legs"], ["hat", "Head"], ["socks", "Feet"]] }
  ];
  var MIN = 20, MAX = 65, SPAN = MAX - MIN;
  var pct = function (t) { return ((t - MIN) / SPAN) * 100; };
  var money = function (n) { return new Intl.NumberFormat(undefined, {style:"currency",currency:JSON.parse(document.getElementById("ts-fw-config").textContent).currency}).format(n / 100); };
  var bandFor = function (t) { for (var i = 0; i < BANDS.length; i++) if (t >= BANDS[i].min && t <= BANDS[i].max) return BANDS[i]; return BANDS[BANDS.length - 1]; };

  var $ = function (id) { return document.getElementById(id); };
  var range = $("temp"), thermo = document.querySelector(".thermo");
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // Zone labels and tick marks along the dial.
  var zones = $("zones");
  BANDS.forEach(function (b) {
    var s = document.createElement("span");
    s.textContent = b.name;
    s.dataset.band = b.id;
    s.style.left = pct((b.min + Math.min(b.max + 1, MAX)) / 2) + "%";
    zones.appendChild(s);
  });
  var ticks = $("ticks");
  for (var t = MIN; t <= MAX; t += 5) {
    var i = document.createElement("i");
    i.style.left = "calc(" + pct(t) + "% + " + (11 - 22 * pct(t) / 100) + "px)";
    if (t % 10 === 0) {
      i.className = "major";
      var b = document.createElement("b");
      b.textContent = t + "°";
      b.style.left = i.style.left;
      ticks.appendChild(b);
    }
    ticks.appendChild(i);
  }
  var presets = $("presets");
  BANDS.slice().reverse().forEach(function (b) {
    var btn = document.createElement("button");
    btn.type = "button";
    btn.id = "preset-" + b.id;
    btn.textContent = b.name + " " + b.preset + "°";
    btn.addEventListener("click", function () { range.value = b.preset; render(true); });
    presets.appendChild(btn);
  });

  // Section tint: frost at the cold end, warm paper at the mild end.
  var COLD = [237, 241, 245], WARM = [247, 241, 231];
  var mix = function (t) {
    var k = (t - MIN) / SPAN;
    return "rgb(" + COLD.map(function (c, j) { return Math.round(c + (WARM[j] - c) * k); }).join(",") + ")";
  };

  var lastBand = null;
  function render(animate) {
    var t = parseInt(range.value, 10);
    var band = bandFor(t);
    $("deg").textContent = t;
    $("degc").textContent = Math.round((t - 32) * 5 / 9) + "°C";
    $("deg-inline").textContent = t + "°F";
    range.style.setProperty("--pct", pct(t) + "%");
    range.setAttribute("aria-valuetext", t + " degrees Fahrenheit, " + band.name);
    thermo.style.setProperty("--tint", mix(t));
    zones.querySelectorAll("span").forEach(function (s) { s.classList.toggle("on", s.dataset.band === band.id); });
    presets.querySelectorAll("button").forEach(function (b) { b.setAttribute("aria-pressed", b.id === "preset-" + band.id ? "true" : "false"); });
    if (band === lastBand) return;
    lastBand = band;
    $("band-name").textContent = band.name;
    $("band-text").textContent = band.text;
    var list = $("kit-list"), total = 0;
    list.innerHTML = "";
    band.kit.forEach(function (pair, n) {
      var p = P[pair[0]];
      total += p.price;
      var li = document.createElement("li");
      if (animate && !reduce) { li.className = "enter"; li.style.animationDelay = (n * 55) + "ms"; }
      li.innerHTML =
        '<a href="' + p.url + '">' +
          '<span class="thumb"><img src="' + p.img + '" width="900" height="900" alt="' + p.name + '" loading="lazy"></span>' +
          '<span class="role label">' + pair[1] + '</span>' +
          '<span class="nm">' + p.short + '</span>' +
          '<span class="pr">' + (p.available ? money(p.price) : "Sold out") + '</span>' +
        '</a>';
      list.appendChild(li);
    });
    list.setAttribute("data-count", band.kit.length);
    $("count").textContent = band.kit.length + " pieces";
    $("total").textContent = band.kit.every(function(pair){return P[pair[0]].available;}) ? "From " + money(total) : "Some pieces unavailable";
  }
  range.addEventListener("input", function () { render(true); });
  render(false);

  // The full-kit ledger.
  var order = ["vancortlandt", "harrier", "brighton", "twilight", "turnover", "shorts", "hat", "beanie", "gloves", "socks"];
  var ol = $("ledger"), sum = 0;
  order.forEach(function (key, n) {
    var p = P[key]; sum += p.price;
    var li = document.createElement("li");
    li.innerHTML = '<a href="' + p.url + '"><span class="no">' + String(n + 1).padStart(2, "0") + '</span>' +
      '<span class="it">' + p.name + '<small>' + p.tag + '</small></span><span class="pr">' + (p.available ? money(p.price) : "Sold out") + '</span></a>';
    ol.appendChild(li);
  });
  $("ledger-total").textContent = order.every(function(key){return P[key].available;}) ? "From " + money(sum) : "Some pieces unavailable";

  // Header turns solid once the hero has scrolled away.
  var header = document.querySelector(".site-header"), hero = document.querySelector(".hero");
  if ("IntersectionObserver" in window) {
    new IntersectionObserver(function (e) { header.classList.toggle("is-solid", !e[0].isIntersecting); },
      { rootMargin: "-80px 0px 0px 0px" }).observe(hero);
  } else {
    header.classList.add("is-solid");
  }
})();
